var map = {
	"./BankOfBH.svg": "uVQg",
	"./BankOfBJ.svg": "ZAiP",
	"./BankOfCD.svg": "T72f",
	"./BankOfChina.svg": "IucQ",
	"./BankOfGD.svg": "yNsb",
	"./BankOfGF.svg": "EeS6",
	"./BankOfGS.svg": "nj+j",
	"./BankOfHX.svg": "sSQl",
	"./BankOfJS.svg": "z1Kb",
	"./BankOfJT.svg": "8rQl",
	"./BankOfMS.svg": "olRc",
	"./BankOfNB.svg": "LyRl",
	"./BankOfNY.svg": "vSBq",
	"./BankOfPA.svg": "3Ufv",
	"./BankOfPF.svg": "ZVUw",
	"./BankOfSH.svg": "o0yK",
	"./BankOfSZ.svg": "KR2D",
	"./BankOfUC.svg": "jxkn",
	"./BankOfXY.svg": "9eGH",
	"./BankOfZS.svg": "fTEo",
	"./BankOfZX.svg": "olYk",
	"./aq.svg": "T3zi",
	"./arrow_right.svg": "uvSz",
	"./back.svg": "kDGn",
	"./bg_login.svg": "OblN",
	"./close.svg": "u1j4",
	"./collect.svg": "Tw70",
	"./collect_no.svg": "3wPO",
	"./deal_failed.svg": "c6pg",
	"./deal_failed2.svg": "Qzx6",
	"./delete.svg": "NUrT",
	"./down.svg": "c1xO",
	"./eye.svg": "ekvI",
	"./eyesshow.svg": "i7es",
	"./head.svg": "curi",
	"./hide_text.svg": "6+4C",
	"./home.svg": "vIvP",
	"./home2.svg": "wT+0",
	"./home4.svg": "ztOW",
	"./home_n.svg": "W8iY",
	"./home_y.svg": "qc/N",
	"./hot_sell.svg": "Ddtl",
	"./icon-xAccount-logo.svg": "+M6z",
	"./large_amount.svg": "WAhN",
	"./like.svg": "PK0I",
	"./like_fill.svg": "cehI",
	"./logo_login.svg": "Vdk9",
	"./lqb.svg": "P5bQ",
	"./me.svg": "2W8v",
	"./me2.svg": "h4U4",
	"./me_n.svg": "PtrF",
	"./me_y.svg": "xWO8",
	"./money-big.svg": "Y0Bn",
	"./money-big2.svg": "N1Kv",
	"./money.svg": "NGFH",
	"./money2.svg": "1qxh",
	"./money_n.svg": "mJ1v",
	"./money_y.svg": "Ix52",
	"./my_bankcard.svg": "9oLW",
	"./my_bankcard2.svg": "jPFo",
	"./my_deal.svg": "FizM",
	"./my_deal2.svg": "Cw2z",
	"./my_estimateValue.svg": "AZZa",
	"./my_investcount.svg": "Q0ut",
	"./my_target.svg": "pEkz",
	"./my_timeinvest.svg": "0aV6",
	"./my_timeinvest2.svg": "BZQl",
	"./my_zcsearch.svg": "Ig6g",
	"./my_zcsearch2.svg": "Jz/v",
	"./news.svg": "xmo5",
	"./next.svg": "DhCr",
	"./risk_type.svg": "pVVZ",
	"./search.svg": "0R99",
	"./search2.svg": "o74z",
	"./setting.svg": "5qFs",
	"./setting2.svg": "XNxl",
	"./show_text.svg": "Uhv7",
	"./small_n.svg": "c7Hc",
	"./small_y.svg": "lSKM",
	"./sort_down.svg": "evBo",
	"./sort_up.svg": "iYXs",
	"./success.svg": "cQmE",
	"./success2.svg": "Q/8y",
	"./timeInvest.svg": "QI8y",
	"./up.svg": "80vx",
	"./waiting_pay.svg": "XQNY",
	"./waiting_pay2.svg": "YO6C",
	"./warn.svg": "2DJv",
	"./warn2.svg": "YM2A",
	"./yes.svg": "OcM9",
	"./上海浦东发展银行.svg": "Igqw",
	"./上海银行.svg": "npK0",
	"./中信银行.svg": "QGef",
	"./中国交通银行.svg": "DQ+i",
	"./中国光大银行.svg": "uqoA",
	"./中国农业银行.svg": "gqhw",
	"./中国工商银行.svg": "IJpH",
	"./中国建设银行.svg": "OQHd",
	"./中国民生银行.svg": "fBU3",
	"./中国银行.svg": "ZeVi",
	"./兴业银行.svg": "0RFf",
	"./北京银行.svg": "663V",
	"./华夏银行.svg": "k4xQ",
	"./宁波银行.svg": "WPI4",
	"./平安银行.svg": "C6Ww",
	"./广东发展银行.svg": "T/fY",
	"./招商银行.svg": "I+jv",
	"./苏州银行.svg": "0621",
	"./邮储银行logo.svg": "2ikZ",
	"./银联标.svg": "wxJu",
	"./银行卡.svg": "fyyA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DwwP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg \.svg$
// module id = DwwP
// module chunks = 37